import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { isAxiosForbidden } from "../../queries/staff-regulators/httpErrors";

export const staffRegulatorsErrorMessage = (
  error: unknown,
  fallback: string,
): string =>
  isAxiosForbidden(error)
    ? AppStrings.COMPLIANCE_REGULATORS_NOT_ALLOWED
    : getApiErrorMessage(error, fallback);
